import type { FC } from "react";
import { allTrackers } from "app/services/track/track";
import { keywordAnalysisHrefFilter, adsFilterFilter } from "app/filters/ngFilters";
import { proNavigator } from "single-spa/react-app/ProNavigator";

interface KeywordCellProps {
    keyword: string;
    allowLinking: boolean;
    childCount: number;
    showGoogleSearch: boolean;
    showAdSearch: boolean;
}

export const WaCellKeywordBase: FC<KeywordCellProps> = ({
    keyword,
    allowLinking,
    childCount,
    showGoogleSearch,
    showAdSearch,
}) => {
    function trackKeyword() {
        allTrackers.trackEvent("Internal Link", "click", "Table/" + keyword);
    }

    return (
        <div
            className="swTable-keywordCell"
            style={{ position: "relative", width: "100%" }}
        >
            <span>
                {" "}
                {allowLinking ? (
                    <span>
                        <a
                            href={keywordAnalysisHrefFilter(proNavigator)(keyword, null)}
                            onClick={trackKeyword}
                            className="swTable-content"
                        >
                            {keyword}
                        </a>
                    </span>
                ) : (
                    <span>
                        {" "}
                        <span className="swTable-content">{keyword}</span>{" "}
                    </span>
                )}{" "}
            </span>
            {childCount ? <span>{`(${childCount})`}</span> : null}
            {showGoogleSearch ? (
                <a
                    className="magnifySearch sw-btn-search-press"
                    href={`https://google.com/search?q=${keyword}`}
                    target="_blank"
                    rel="noreferrer"
                />
            ) : null}
            {showAdSearch ? (
                <a
                    className="btn-search-ads"
                    href={adsFilterFilter(proNavigator)(keyword)}
                    target="_self"
                >
                    Ads
                </a>
            ) : null}
        </div>
    );
};
WaCellKeywordBase.displayName = "WaCellKeywordBase";
